import React from "react";

function Cans() {
  return (
    <div>
      <h1>Cans Product Page</h1>
      <p>Описание cans продукта...</p>
    </div>
  );
}

export default Cans;